// src/pages/syntramfg/components/SyntraMetaverseMarketplace.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";

const marketplaceData = {
  "Raw Materials": {
    "Steel Market": ["Steel Sheets", "Iron Rods", "All Raw Materials"],
    "Plastics Hub": ["Polymer Granules", "PVC Pipes", "All Plastics"],
  },
  "Machinery": {
    "Machine Mart": ["CNC Machine", "Lathe Machine", "All Machinery"],
    "Robotics Zone": ["Industrial Robot", "3D Printer", "All Automation"],
  },
  "Electronics": {
    "Electro World": ["Microchips", "Sensors", "All Electronics"],
    "Circuit Hub": ["PCB Boards", "Capacitors", "All Components"],
  },
  "Packaging": {
    "PackMart": ["Cardboard Boxes", "Plastic Wraps", "All Packaging"],
  },
  "Finished Goods": {
    "Product Hub": ["Automobiles", "Furniture", "All Products"],
  },
};

const sellersData = {
  "Steel Sheets": ["Steel Supplier A", "Steel Supplier B"],
  "Iron Rods": ["IronWorks Ltd", "Global Metals"],
  "Polymer Granules": ["Plastics Corp", "EcoPoly Pvt Ltd"],
  "CNC Machine": ["Machinery Maker 1", "Machinery Maker 2"],
  "Lathe Machine": ["Precision Tools Ltd"],
  "Industrial Robot": ["Automation Inc", "Robotics Solutions"],
  "3D Printer": ["PrintTech 3D", "Innovators Hub"],
  "Microchips": ["Chipset Supplier 1", "Chipset Supplier 2"],
  "Sensors": ["SensorTech", "Smart Electronics"],
  "PCB Boards": ["PCB Factory A", "PCB Factory B"],
  "Capacitors": ["ElectroParts Ltd"],
  "Cardboard Boxes": ["Packers Co", "EcoBox Supplies"],
  "Plastic Wraps": ["WrapItUp Pvt Ltd"],
  "Automobiles": ["Car Maker 1", "Car Maker 2"],
  "Furniture": ["WoodWorks", "HomeMakers"],
};

const productImages = {
  "Steel Sheets":
    "https://images.unsplash.com/photo-1562183241-b937e95585b6?auto=format&fit=crop&w=800&q=60",
  "Iron Rods":
    "https://images.unsplash.com/photo-1599940824399-b87987ceb72a?auto=format&fit=crop&w=800&q=60",
  "Polymer Granules":
    "https://images.unsplash.com/photo-1630677808402-6fa41063f636?auto=format&fit=crop&w=800&q=60",
  "CNC Machine":
    "https://images.unsplash.com/photo-1625838144800-750b9f98d1a6?auto=format&fit=crop&w=800&q=60",
  "Lathe Machine":
    "https://images.unsplash.com/photo-1630677807593-2d07a1b5c8de?auto=format&fit=crop&w=800&q=60",
  "Industrial Robot":
    "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=60",
  "3D Printer":
    "https://images.unsplash.com/photo-1612815154858-60d52a2e9f15?auto=format&fit=crop&w=800&q=60",
  Microchips:
    "https://images.unsplash.com/photo-1587202372775-98927f95e7f9?auto=format&fit=crop&w=800&q=60",
  Sensors:
    "https://images.unsplash.com/photo-1581090700227-4c4c92b9e5a5?auto=format&fit=crop&w=800&q=60",
  "PCB Boards":
    "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?auto=format&fit=crop&w=800&q=60",
  Capacitors:
    "https://images.unsplash.com/photo-1612810806449-70e2b8cb4c0a?auto=format&fit=crop&w=800&q=60",
  "Cardboard Boxes":
    "https://images.unsplash.com/photo-1593079831268-3381b0db4a77?auto=format&fit=crop&w=800&q=60",
  "Plastic Wraps":
    "https://images.unsplash.com/photo-1617957741643-d2c4d0f90b9a?auto=format&fit=crop&w=800&q=60",
  Automobiles:
    "https://images.unsplash.com/photo-1605559424843-9c0e9f4504a5?auto=format&fit=crop&w=800&q=60",
  Furniture:
    "https://images.unsplash.com/photo-1616628182505-5eecf66da29f?auto=format&fit=crop&w=800&q=60",
};

const SyntraMetaverseMarketplace = () => {
  const [category, setCategory] = useState("");
  const [market, setMarket] = useState("");
  const [product, setProduct] = useState("");

  const availableMarkets = category ? Object.keys(marketplaceData[category]) : [];
  const availableProducts =
    category && market ? marketplaceData[category][market] : [];
  const sellers = product ? sellersData[product] || [] : [];

  // Random Offer Display
  const hasOffer = () => Math.random() < 0.3;

  return (
    <div className="w-full max-w-6xl mx-auto mt-12 p-6">
      <h2 className="text-3xl font-bold text-blue-900 mb-6 text-center">
        🏭 SyntraMFG Metaverse Marketplace
      </h2>

      {/* Selection Controls */}
      <div className="flex flex-col md:flex-row gap-4 mb-8 justify-center items-center">
        <select
          className="border p-2 rounded-lg h-10"
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
            setMarket("");
            setProduct("");
          }}
        >
          <option value="">Select Category</option>
          {Object.keys(marketplaceData).map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        <select
          className="border p-2 rounded-lg h-10"
          value={market}
          onChange={(e) => {
            setMarket(e.target.value);
            setProduct("");
          }}
          disabled={!category}
        >
          <option value="">Select Market</option>
          {availableMarkets.map((mkt) => (
            <option key={mkt} value={mkt}>
              {mkt}
            </option>
          ))}
        </select>

        <select
          className="border p-2 rounded-lg h-10"
          value={product}
          onChange={(e) => setProduct(e.target.value)}
          disabled={!market}
        >
          <option value="">Select Product</option>
          {availableProducts.map((prod) => (
            <option key={prod} value={prod}>
              {prod}
            </option>
          ))}
        </select>
      </div>

      {/* Product Backdrop with Sellers Overlay */}
      {product && productImages[product] && (
        <div className="relative w-full h-[500px] rounded-2xl shadow-lg overflow-hidden">
          <img
            src={productImages[product]}
            alt={product}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col">
            {market && (
              <h3 className="text-center text-2xl md:text-3xl font-bold text-white mt-4">
                {market}
              </h3>
            )}

            <div className="flex-1 p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto">
              {sellers.map((seller) => (
                <motion.div
                  key={seller}
                  className="bg-white bg-opacity-80 rounded-lg p-4 shadow-md flex flex-col justify-between hover:scale-105 transition-transform relative"
                >
                  <div className="font-semibold text-blue-900">{seller}</div>
                  {hasOffer() && (
                    <span className="absolute top-2 right-2 bg-yellow-400 text-xs px-2 py-1 rounded-full animate-pulse">
                      This Seller has an Offer
                    </span>
                  )}
                  <Link
                    to="/syntramfg-digitaltwin"
                    state={{ seller, product, market }}
                    className="mt-4 bg-blue-700 text-white px-3 py-1 rounded-lg hover:bg-blue-800 text-center"
                  >
                    Digital Twin
                  </Link>
                </motion.div>
              ))}
              {sellers.length === 0 && (
                <p className="text-white text-center col-span-full">
                  No sellers found for {product}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SyntraMetaverseMarketplace;
